import { IJob } from '@medely/types';
import { Analytics } from '@medely/ui-kit';
import { useCurrentUser } from './useCurrentUser';
import { useOTAMetadata } from './useOTAMetadata';

export type TrackClockOutData = {
  rounded?: boolean;
  actual_clock_out_time?: string;
  scheduled_clock_out_time?: string;
  time_overridden?: boolean;
  was_530_verification_overridden?: boolean;
  was_geofence_overridden?: boolean;
};

export const usePerDiemEventTracking = (analytics: Analytics) => {
  const { proType } = useCurrentUser();
  const otaMetadata = useOTAMetadata();

  return {
    trackBooked: (jobId: IJob['id']) => {
      analytics.track('Staff Booking', { Job_ID: jobId, ...otaMetadata });
      analytics.track({
        Job_ID: jobId,
        context: 'Job Booking',
        subcontext: 'Book Button',
        action: 'Clicked',
        pro_type: proType,
        ...otaMetadata,
      });
    },
    trackCanceled: (jobId: IJob['id']) => {
      analytics.track('Staff Cancelations', { Job_ID: jobId, ...otaMetadata });
      analytics.track({
        Job_ID: jobId,
        context: 'Job Details',
        subcontext: 'Cancel Button',
        action: 'Clicked',
        pro_type: proType,
        ...otaMetadata,
      });
    },
    /**
     * @deprecated Use the trackStartShiftConfirm from useClockInOutEvent instead
     */
    trackClockIn: (jobId: IJob['id']) => {
      analytics.track('Staff Clock In', { Job_ID: jobId, ...otaMetadata });
      analytics.track({
        Job_ID: jobId,
        context: 'Start Shift',
        subcontext: 'Confirm Button',
        action: 'Clicked',
        pro_type: proType,
        ...otaMetadata,
      });
    },
    trackClockOut: (jobId: IJob['id'], trackingData?: TrackClockOutData) => {
      analytics.track('Staff Clock Out', { Job_ID: jobId, ...otaMetadata });
      analytics.track({
        Job_ID: jobId,
        context: 'End Shift',
        subcontext: 'Confirm Button',
        action: 'Clicked',
        impersonating: false,
        pro_type: proType,
        ...trackingData,
        ...otaMetadata,
      });
    },
    trackShiftDetailsReview: (jobId?: IJob['id'] | null) => {
      analytics.track('Job Booking - Viewed', {
        Job_ID: jobId,
        context: 'Job Booking',
        action: 'Viewed',
        pro_type: proType,
        ...otaMetadata,
      });
    },
  };
};
